import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { getURLByRouteName } from '../../utils/routes'
import { langTexts } from './locals'

import logo from '../../assets/images/sanfer_logo.png'
import fbLogo from '../../assets/images/social_networks/facebook.png'
import linkedinLogo from '../../assets/images/social_networks/linkedin.png'
import twitterLogo from '../../assets/images/social_networks/twitter.png'
import instaLogo from '../../assets/images/social_networks/instagram.png'

import './index.css'

const Footer = props => {
  const { lang } = props.settings
    , texts = langTexts[lang]

  return <div id='footer'>
    <div className='footer__links'>
      <div className='footer__external-links'>
        <h5>{texts.groupCompanies}</h5>
        <a href='https://pharmadorf.com.ar/' target='_blank' rel='noreferrer'>
          <span>Argentina</span>
        </a>
        <a href='https://www.lpasteur.cl/' target='_blank' rel='noreferrer'>
          <span>Chile</span>
        </a>
        <a href='http://bussie.com.co/?r=site/servicios' target='_blank' rel='noreferrer'>
          <span>Colombia</span>
        </a>
        <p>Ecuador</p>
        <p>México</p>
        <a href='https://www.laboratoriosportugal.com/' target='_blank' rel='noreferrer'>
          <span>Perú</span>
        </a>
      </div>
      <div className='footer__legal-links'>
        <h5>{texts.legals}</h5>
        <Link to={getURLByRouteName('codeOfEthics')}>
          <span>{texts.codeOfEthics}</span>
        </Link>
        <Link to={getURLByRouteName('authorizationKeys')}>
          <span>{texts.authorizationKeys}</span>
        </Link>
        <Link to={getURLByRouteName('noticeOfPrivacy')}>
          <span>{texts.noticeOfPrivacy}</span>
        </Link>
      </div>
    </div>
    <div className='footer__social'>
      <img className='logo' src={logo} alt='SANFER' />
      <div className='social-networks'>
        <a className='social-networks__icon transition' href='https://www.instagram.com/sanfermexico/' target='_blank' rel='noreferrer'>
          <img src={instaLogo} alt='Facebook' style={{ background: 'white', borderRadius: '50%' }} />
        </a>
        <a className='social-networks__icon transition' href='https://www.facebook.com/SanferMexico/' target='_blank' rel='noreferrer'>
          <img src={fbLogo} alt='Facebook' />
        </a>
        <a className='social-networks__icon transition' href='https://mx.linkedin.com/company/sanfer?trk=similar-pages_result-card_full-click' target='_blank' rel='noreferrer'>
          <img src={linkedinLogo} alt='LinkedId' />
        </a>
        <a className='social-networks__icon transition' href='https://twitter.com/sanfer_mx' target='_blank' rel='noreferrer'>
          <img src={twitterLogo} alt='Twitter' />
        </a>
      </div>
      <p>© LABORATORIOS SANFER 2020, Todos los derechos reservados</p>
    </div>
  </div>
}

const mapStateToProps = state => ({
  settings: state.settings
})


export default connect(mapStateToProps)(Footer)